import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component, useState } from 'react';
import { ErrorMessage } from 'formik';
import uniqueId from 'lodash.uniqueid';
import { Form } from 'react-bootstrap'; // Global Form Methods

import FormMethods from './Methods';

var FormSelect = /*#__PURE__*/function (_Component) {
  _inherits(FormSelect, _Component);

  var _super = _createSuper(FormSelect);

  function FormSelect(props) {
    var _this;

    _classCallCheck(this, FormSelect);

    _this = _super.call(this, props);
    _this.handleFocus = FormMethods.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = FormMethods.handleBlur.bind(_assertThisInitialized(_this));
    _this.state = {
      name: props.field.name,
      active: typeof props.value !== 'undefined' && props.value !== '' ? true : false,
      value: typeof props.value !== 'undefined' && props.value !== '' ? props.value : null
    };
    _this.id = uniqueId();
    return _this;
  }

  _createClass(FormSelect, [{
    key: "onChange",
    value: function onChange(e, setFieldValue) {
      this.props.form.setFieldValue(e.currentTarget.name, e.currentTarget.value);

      if (typeof this.props.changeHandler !== 'undefined') {
        return this.props.changeHandler(e);
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$field = _this$props.field,
          name = _this$props$field.name,
          field = _objectWithoutProperties(_this$props$field, ["name"]),
          props = _objectWithoutProperties(_this$props, ["field"]);

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
        controlId: "".concat(this.props.field.name, "-").concat(this.id)
      }, !this.props.hideLabel ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "\n              cb-form__label--select\n              ".concat(this.state.active ? 'is-active' : '', "\n              ").concat(typeof field.value !== 'undefined' && field.value !== '' ? 'is-filled' : '', "\n            ")
      }, this.props.label || name) : null, /*#__PURE__*/React.createElement("div", {
        className: "cb-form__select-wrapper"
      }, /*#__PURE__*/React.createElement(Form.Control, {
        as: "select",
        className: "\n                cb-form__select\n                form-control\n                ".concat(this.state.active ? 'is-active' : '', "\n                ").concat(typeof field.value !== 'undefined' && field.value !== '' ? 'is-filled' : '', "\n              "),
        defaultValue: this.state.value,
        name: this.props.field.name,
        onChange: function onChange(e) {
          return _this2.onChange(e);
        },
        onBlur: field.onBlur,
        onFocus: this.handleFocus,
        onError: field.handleError
      }, this.props.options.map(function (option, index) {
        return /*#__PURE__*/React.createElement("option", {
          value: option.value,
          key: index,
          id: "".concat(_this2.props.id || _this2.id, "-option-").concat(index)
        }, option.label);
      }))), /*#__PURE__*/React.createElement(ErrorMessage, {
        name: name
      }, function (msg) {
        return /*#__PURE__*/React.createElement("div", {
          className: "cb-form__error-message"
        }, msg);
      })));
    }
  }]);

  return FormSelect;
}(Component);

FormSelect.defaultProps = {
  opttions: [],
  className: ""
};
export default FormSelect;